import useAxios from "axios-hooks";
import { formatUrl } from "utils";

import { ClientParams, api } from "config/urls";

import { ApiError, ConfigResponse } from "./shared";

export interface CreateCompanyBody {
  name: string;
}

export interface CreateCompanyResponse {
  id: string;
  created: Date;
}

export const useClientConfigQuery = ({
  clientId,
  queryParams,
}: ClientParams & { queryParams: URLSearchParams }) => {
  return useAxios<ConfigResponse, ApiError>({
    url: formatUrl<ClientParams>(api.clients.config, { clientId }),
    params: queryParams,
  });
};

export const useCreateCompanyQuery = ({ clientId }: ClientParams) => {
  return useAxios<
    CreateCompanyResponse,
    {
      name: string | null;
      createdByUserId: string | null;
      description?: string;
    },
    ApiError
  >(
    {
      url: formatUrl<ClientParams>(api.clients.create, { clientId }),
      method: "POST",
    },
    { manual: true }
  );
};

export interface CompanyLimitReachedResponse {
  limitReached: boolean;
}

export const useCompanyLimitReachedQuery = ({ clientId }: ClientParams) => {
  return useAxios<CompanyLimitReachedResponse, ApiError>({
    url: formatUrl<ClientParams>(api.clients.companyLimitReached, { clientId }),
    method: "GET",
  });
};
